import { Link } from "@tanstack/react-router";
import { Instagram, Facebook } from "lucide-react";
import logoBadge from "@/assets/plunkets-badge.png";

export function SiteFooter() {
  return (
    <footer id="book" className="relative overflow-hidden border-t border-border bg-card/50 px-5 pt-12 md:px-8 md:pt-16">
      <div className="pointer-events-none absolute -top-40 left-1/2 h-96 w-[40rem] -translate-x-1/2 rounded-full bg-primary/15 blur-3xl" />
      <div className="relative mx-auto max-w-7xl">
        <div className="grid gap-10 md:grid-cols-4">
          <div>
            <img
              src={logoBadge}
              alt="Plunkets badge — Est. 2025"
              width={140}
              height={140}
              loading="lazy"
              decoding="async"
              className="h-28 w-28"
            />
            <p className="mt-4 text-sm text-muted-foreground">
              Live Music. Sports. Good Times. In the heart of Dublin city centre. Est. 2025.
            </p>
            <div className="mt-5 flex gap-3">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                className="rounded-full border border-border p-2 text-muted-foreground transition hover:border-primary hover:text-primary"
              >
                <Instagram size={16} />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
                className="rounded-full border border-border p-2 text-muted-foreground transition hover:border-primary hover:text-primary"
              >
                <Facebook size={16} />
              </a>
            </div>
          </div>
          <div>
            <h3 className="mb-3 text-xs uppercase tracking-[0.2em] text-primary">Visit</h3>
            <p className="text-sm text-muted-foreground">
              Middle Abbey Street<br />Dublin 1, D01<br />Ireland
            </p>
          </div>
          <div>
            <h3 className="mb-3 text-xs uppercase tracking-[0.2em] text-primary">Hours</h3>
            <p className="text-sm text-muted-foreground">Open daily · 12:00 – 23:30 · Fri & Sat until 00:30</p>
          </div>
          <div>
            <h3 className="mb-3 text-xs uppercase tracking-[0.2em] text-primary">Quick Links</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/" className="hover:text-primary">Home</Link></li>
              <li><Link to="/pooltable-dublin-citycenter" className="hover:text-primary">Pool & Darts</Link></li>
              <li><Link to="/food-menu" className="hover:text-primary">Food Menu</Link></li>
              <li><Link to="/cocktails" className="hover:text-primary">Cocktails</Link></li>
              <li><Link to="/events" className="hover:text-primary">Events</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-border py-8 text-xs text-muted-foreground md:flex-row">
          <p>© {new Date().getFullYear()} Plunkets Pub Dublin. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="transition hover:text-primary">
              Privacy Policy
            </Link>
            <p>Crafted in Dublin · Middle Abbey Street</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
